import './index.css';

const Contact = () => {
    return(
        <div>
            <h1 className="color2">This is Contact page.</h1>
        </div>
    );   
};
export default Contact;